<template>
  <div class="row">
    <div class="col">
      <div class="row">
        <div class="col">
          <div class="page-header centrer">
            <div class="row">
              <div class="col-11"/>
              <div class="col-1 text-right no-print">
                <Button label="Imprimer" v-on:click="imprimer"/>
              </div>
            </div>
            <div class="row">
              <div class="col-1"/>
              <div class="col-10">
                <h1>Historique des actions du mandat</h1>
              </div>
              <div class="col-1 text-right no-print">
                  <Button label="Fermer" v-on:click="fermer"/>
              </div>
            </div>
            <h3 class="confidentiel">Confidentiel</h3>
            <h3 v-if="isDataLoaded">
              Mandat : {{ numeroMandat }} <br />
            </h3>
            <div v-else>
              <Skeleton />
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <table class="centrer">
            <thead>
              <tr>
                <td>
                  <!--place holder for the fixed-position header-->
                  <div class="page-header-space"></div>
                </td>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td>
                  <!--*** CONTENT GOES HERE ***-->
                  <div>
                    <TableActionsMandatPSU
                      @isDataLoaded="getIsDataLoaded"
                    />
                  </div>
                </td>
              </tr>
            </tbody>

            <tfoot>
              <tr>
                <td>
                  <!--place holder for the fixed-position footer-->
                  <div class="page-footer-space"></div>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <div class="page-footer centrer">
            <p>Généré le {{ getCurrentDateTime() }} par {{ currentUser }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TableActionsMandatPSU from "../../../components/dossier/AnnexeDossier/TableActionsMandatPSU.vue";
import commun from "../../../commun";
import axios from "axios";
import { mapGetters } from "vuex";

export default {
  name: "historiqueActionsMandatPSU",
  components: {
    TableActionsMandatPSU,
  },
  data() {
    return {
      currentUser: "",
      numeroMandat: "",
      isDataLoaded: false,
    };
  },
  computed: {
    ...mapGetters({
      jeton: "cardex/jeton",
      profil: 'cardex/profil',
    }),
  },
  methods: {
    assignerInformationUtilisateur(res) {
      this.currentUser = res.data.codeProfilUtilisateur;
    },
    fermer() {
        this.$root.$refs.breadcrumbComp.rediriger();
    }, 
    getCurrentDateTime() {
      return commun.formatDateHeure(new Date());
    },
    getIsDataLoaded(value) {
      this.isDataLoaded = value;
    },
    imprimer(){
      window.print();
    }
  },
  mounted() {
    axios.defaults.headers.common["cleProfil"] = this.profil.cle;
    this.numeroMandat = this.$route.params.numeroMandat;
    this.$root.$refs.breadcrumbComp.ajout("Historique des actions du mandat");
    this.$store.dispatch("vehicule/obtenirProfilAction").then((res) => {
      this.assignerInformationUtilisateur(res);
    });
  },
};
</script>